module.exports = __webpack_public_path__ + "static/img/Dustin-Martin.a3be2c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dustin-Martin.jpg
// module id = dz0a
// module chunks = 0